import React, { createContext } from "react";
import { RouterProvider as ReactRouterProvider } from "react-router-dom";
import BrowserRouter from "router";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.scss";
import "./localization/i18n";
import { bootSegment } from "helpers/analyticsHelpers";
import promiseFinally from "promise.prototype.finally";
import { Client } from "api/client";
import "helpers/polyfills";
import store from "./store/store";
import braze from "helpers/braze";
import { AppWrapper } from "components/AppWrapper";
import { ClientCore } from "api/client-core";

promiseFinally.shim();
bootSegment();
braze.init();

const switcherClient = new Client({ showLoading: false });
const switcherClientCore = new ClientCore({ showLoading: false });
export const SwitcherClientContext = createContext({
    switcherClient,
    switcherClientCore
});

const persistor = persistStore(store);

const App = () => {
    return (
        <Provider store={store}>
            <SwitcherClientContext.Provider
                value={{
                    switcherClient,
                    switcherClientCore
                }}
            >
                <PersistGate loading={null} persistor={persistor}>
                    <AppWrapper>
                        <ReactRouterProvider router={BrowserRouter()} />
                    </AppWrapper>
                </PersistGate>
            </SwitcherClientContext.Provider>
        </Provider>
    );
};

export default App;
